import { Badge } from "reactstrap";
import Ranga from "../enums/Ranga";
import MainLoader from "./MainLoader";
import { useEffect, useState } from "react";
import { imprezyService } from "../service/Imprezy";
import ImprezaDetails from "./ImprezaDetails";
import Popup from "./Popup";

const Impreza = ({ino, isAdmin, update}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState();
  const [draftDetails, setDraftDetails] = useState();

  const handleDraftChange = (draft) => {
    setDraftDetails(draft);
  };

  const getDetails = (id) => {
    setLoading(true);
    imprezyService.getDetails(id).then((response) => {
      setDetails(response.data);
      setDraftDetails(response.data);
      setLoading(false);
    });
  }

  useEffect(() => {
    if (open && !details) {
      getDetails(ino.Id);
    }
  }, [open]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSave = () => {
    const payload = draftDetails ?? details;
    if (!payload?.Id) {
      return;
    }

    setLoading(true);
    imprezyService.saveImpreza(payload).then((response) => {
      const updated = response?.data ?? response;
      if (updated?.Id) {
        setDetails(updated);
        setDraftDetails(updated);
        update?.(updated);
      }
      setLoading(false);
      setOpen(false);
    }).catch(() => {
      setLoading(false);
    });
  };

  return (
    <>
      <div className="ino-container" onClick={handleOpen}>
        <div className="ino-logo">
          <img src={ino.Logo}/>
        </div>
        <div className="ino-content">
          <h4>{ino.Nazwa}</h4>
          <p>
            <i className="fa fa-calendar"></i> {ino.TerminOd} {ino.TerminDo && `do ${ino.TerminDo}`}
          </p>
          <p>
            <i className="fa fa-map-marker"></i> {ino.Miejsce} {ino.Wojewodztwo && `woj. ${ino.Wojewodztwo}`}
          </p>
          {ino.Komentarz && (
            <p className="comment">
              {ino.Komentarz}
            </p>
          )}
          <div className="container-fluid d-flex flex-wrap g8 mt-auto justify-content-center">
            {ino.Rangi && ino.Rangi.length > 0 && ino.Rangi.map((ranga) => <Badge className="ranga">{Ranga[ranga].value}</Badge>)}
          </div>
        </div>
      </div>

      {open && (
        <Popup
          cancel={handleClose}
          title={ino.Nazwa}
          submit={isAdmin ? handleSave : handleClose}
          showSubmit={isAdmin}
        >
          {(loading || !details) 
            ? <MainLoader />
            : <ImprezaDetails 
                details={details}
                admin={isAdmin}
                onDraftChange={handleDraftChange}
              />}
        </Popup>
      )}
    </>
  )
}

export default Impreza
